<template>
  <div class="d-flex justify-content-end w-100">
    <b-button
      pill
      variant="danger"
      class="w-100 w-md-auto my-3 my-md-auto"
      :disabled="modalDisabled"
      @click="decline"
      aria-label="Decline certifying this Notification"
    >
      Decline
    <b-modal
      ref="declineConfirmation"
      content-class="px-lg-5"
      id="declineConfirmation"
      title="Are you sure you want to Decline?"
      footer-class="text-center"
      centered
      hide-header-close
      size="lg"
    >
      <b-form-checkbox
        :disabled="mfsAdmin"
        id="declineAcknowledgement"
        class="mb-3"
        v-model="declineAcknowledgement">
        <span v-if="!isNonNotifierLandowner">As the {{fullRolesList}}, I decline
          to certify this Forest Operations Notification and will not participate
          or accept responsibilities for this Operation.
        </span>
        <span v-else>As the {{fullRolesList}}, I decline the Designated Agent's
          certification of this Forest Operations Notification and will not participate
          or accept responsibilities for this Operation.
        </span>
      </b-form-checkbox>
      <div slot="modal-footer" class="d-flex">
        <b-button
          pill
          variant="danger"
          class="mr-3"
          @click="hideModal"
          aria-label="Cancel declining this Notification"
        >
          Cancel
        </b-button>
        <b-button
          pill
          variant="primary"
          :disabled="mfsAdmin || !declineAcknowledgement"
          @click="declined()"
          aria-label="Confirm declining this Notification"
        >
          Yes, Decline
        </b-button>
      </div>
    </b-modal>
  </b-button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Utilities from '@/mixins/Utilities';

const initialState = () => ({
  declineAcknowledgement: false,
});

export default {
  name: 'DeclineModal',
  mixins: [Utilities],
  props: {
    modalDisabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return initialState();
  },
  computed: {
    ...mapState('Notification', {
      notification: state => state.notification,
      roles: state => state.roles,
    }),
    ...mapState('User', {
      userId: state => state.user.id,
    }),
    ...mapGetters('Notification', ['pendingCertification', 'isBeingCertifiedByDA']),
    ...mapGetters('User', ['mfsAdmin']),
    fullRolesList() {
      const roleStrings = [];
      if (this.roles.landowner) roleStrings.push('Landowner');
      if (this.roles.designatedAgent) roleStrings.push('Designated Agent');
      if (this.roles.operator) roleStrings.push('Harvester/Operator');
      if (this.roles.licensedForester) roleStrings.push('Licensed Forester');

      return this.joinList(roleStrings);
    },
    isNonNotifierLandowner() {
      return this.notification.landownerUser
        && this.notification.landownerUser.id === this.userId
        && this.isBeingCertifiedByDA;
    },
  },
  methods: {
    decline() {
      Object.assign(this.$data, initialState());
      this.$refs.declineConfirmation.show();
    },
    declined() {
      if (this.mfsAdmin) {
        return;
      }
      this.$store.dispatch(
        'Notification/decline',
        this.notification.id,
      );
      this.$emit('declined');
    },
    hideModal() {
      this.$refs.declineConfirmation.hide();
    },
  },
};
</script>
